<template lang="pug">
  v-app.view-home.v-step-0
    v-tour(name="gettingStarted" :steps="steps")
      template(slot-scope="tour")
        transition(name="fade")
          v-step(
            v-if="tour.currentStep === index"
            v-for="(step, index) of tour.steps"
            :key="index"
            :step="step"
            :previous-step="tour.previousStep"
            :next-step="tour.nextStep"
            :stop="tour.stop"
            :is-first="tour.isFirst"
            :is-last="tour.isLast"
            :labels="tour.labels")
              template
                .header(slot="header")
                  h3 {{step.header}}
                .content(slot="content")
                  span(v-html="step.content")
                .actions(slot="actions")
                  v-checkbox.text-capitalize(v-if="tour.isFirst" color="#DEC68A" class="mt-1 ml-1" label="Do not show again" small outline dark @change="doNotShowAgain")
                  v-btn.text-capitalize(v-if="!tour.isLast" small outline dark @click="tour.stop")
                    span Skip Tour
                  v-btn.text-capitalize(v-if="!tour.isFirst" small outline dark @click="tour.previousStep")
                    span Previous
                  v-btn.text-capitalize(v-if="!tour.isLast" small outline color="#DEC68A" @click="tour.nextStep")
                    span Next
                  v-btn.text-capitalize(v-else small outline color="#DEC68A" @click="tour.stop")
                    span Finish
    v-snackbar(
      v-model="snackbar"
      :bottom="true"
      :left="true"
      :timeout="0")
        span.snackcontent(v-html="snackbarText")
        v-btn(flat @click="snackbar = false") CLOSE
    v-snackbar(
      v-model="updateSnackbar"
      :bottom="true"
      :right="true"
      color="primary"
      :timeout="0"
      :multi-line="true")
      | New update is available.
      v-btn(flat @click="refresh" color="white") REFRESH
    v-navigation-drawer(
      app
      fixed
      clipped
      temporary
      width="315"
      value="1"
      :hide-overlay="true"
      :style="drawerStyle"
      :stateless="true"
      v-model="drawer")
        drawer-list
    v-toolbar(
      app
      fixed
      dark
      id="mainToolbar"
      color="primary"
      clipped-left)
        v-toolbar-side-icon(@click.stop="drawer = !drawer")
        div.logo-div
          a.logo-anchor(:href="coloradoURL + '/apps'" target="_blank")
            img.logo-img(src="@/assets/csfs-logo-new.svg" alt="Colorado State Forest Service")
        .apptittle(v-if="$vuetify.breakpoint.smAndUp")
          span.title WILDFIRE RISK VIEWER
          // span.subtitle Wildfire Risk Assesment Viewer
        v-spacer
        v-tooltip(bottom color="secondary")
          v-btn(icon slot="activator" @click="toggleSwipe" v-if="$vuetify.breakpoint.lgAndUp")
            v-icon flip
          span Swipe Tool
        v-tooltip(bottom color="secondary")
          v-btn.v-step-3(icon slot="activator" @click="toggleMeasurement")
            v-icon straighten
          span Measure
        v-tooltip(bottom color="secondary")
          v-btn(icon slot="activator" @click="toggleIdentify")
            v-icon not_listed_location
          span Identify
        v-tooltip(bottom color="secondary")
          v-btn(icon slot="activator" @click="toggleLegend")
            v-icon view_list
          span Legend
        v-tooltip(bottom color="secondary")
          v-btn(icon slot="activator" @click="toogleMenu" )
            v-icon more_vert
          span Menu
    menu-list
    v-content
      // v-speed-dial(
        v-if="$vuetify.breakpoint.xsOnly"
        v-model="fab"
        :top="true"
        :right="true"
        direction="bottom"
        fixed)
          v-btn(
            icon
            slot="activator"
            v-model="fab"
            dark
            fab
            color="secondary")
              v-icon map
              v-icon close
          v-btn(fab small color="primary" @click="toggleMeasurement")
            v-icon straighten
          v-btn(fab small color="primary" @click="toggleIdentify")
            v-icon not_listed_location
          v-btn(fab small color="primary" @click="toggleLegend")
            v-icon view_list
      web-map
    #pseudoIdentifyOverlay.ol-popup
      PseudoIdentifyPopup()
    v-dialog(
      v-model="initialDialog"
      persistent
      width="790")
        initial-dialog(v-on:close="initialDialog = false; startTour();")
</template>

<script>
import DrawerList from "@/components/DrawerList";
import MenuList from "@/components/MenuList";
import WebMap from "@/components/WebMap";
import InitialDialog from "@/components/InitialDialog";
import PseudoIdentifyPopup from "@/components/PseudoIdentifyPopup";
import {
  toggleSwipe,
  toggleMeasurement,
  toggleIdentify,
  toggleLegend,
} from "@/services/map";
import { eventBus } from "@/services/utils";

export default {
  name: "App",
  components: {
    DrawerList,
    MenuList,
    WebMap,
    InitialDialog,
    PseudoIdentifyPopup,
  },
  data() {
    return {
      // fab: false,
      initialDialog: true,
      showPseudoIdentifyPopup: false,
      drawer: true,
      snackbar: false,
      updateSnackbar: false,
      drawerStateless: true,
      drawerStyle: {},
      snackbarText: "",
      steps: [
        {
          target: "body",
          header: "Welcome, take a Quick tour!",
          content: `This tour will introduce you to the basic operation and features of the Colorado Wildfire Risk Viewer. You can close this tour at any time by clicking “Skip”.`,
          params: {
            placement: "none",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: "#olSearch",
          header: "Quick Search",
          content: `Use this search tool to quickly find an address or place name.`,
          params: {
            placement: "bottom",
          },
        },
        {
          target: ".ol-initial-extent",
          header: "Map Navigation & Base Maps",
          content: `Use these tools to change base maps, zoom to your location and zoom in and out on the map.`,
          params: {
            placement: "left",
          },
        },
        {
          target: ".v-step-3",
          header: "Map Tools",
          content: `Use these tools to interact with the map, such as measure distance or area, swipe layers on/off, retrieve attributes for specific layers, or view the legend.`,
          params: {
            placement: "bottom",
            positionFixed: true,
          },
        },
        {
          target: ".v-step-4",
          header: "Reference Layers",
          content: `Turn on/off standard reference map layers such as county boundaries and fire perimeters. Click the “View Layer Description” button to view detailed layer information.`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: 0,
                    top: "12em",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: ".v-step-5",
          header: "Map Themes",
          content: `View a variety of wildfire risk information by selecting any of the available map themes/layers. You can only view one map theme at a time. You may need to scroll to see all layers and more information about them.`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: 0,
                    top: "15em",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: ".v-step-6",
          header: "Identify Your Fire Intensity Tool",
          content: `This tool allows you to select a point on the map and summarize the potential fire intensity for that specific location.`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: 0,
                    top: "18em",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: ".v-step-7",
          header: "County Summary Tool",
          content: `Obtain county reports.`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: 0,
                    top: "22em",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: ".v-step-8",
          header: "Print Map",
          content: `Use this tool to generate a PDF screenshot and legend of the area of interest you have zoomed to on the map. You can also give the map a title and short description.`,
          params: {
            placement: "bottom",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: 0,
                    top: "26em",
                  });
                  return data;
                },
              },
            },
          },
        },
        {
          target: "body",
          header: "Give us Feedback!",
          content: `<p>Tell us what you think of the Colorado Wildfire Risk Viewer.</p>
          <p> We encourage you to give us feedback on your experience using the application, any issues you may have encountered or how we might improve the application. Visit the Contact page through the link in the menu located in the top right of this application’s window.</p>
          <p>Thanks for using the application.</p>`,
          params: {
            placement: "none",
            modifiers: {
              computeStyle: {
                enabled: true,
                fn(data) {
                  data.styles = Object.assign({}, data.styles, {
                    left: "50%",
                    top: "50%",
                    transform: "translate(-50%, -50%)",
                  });
                  return data;
                },
              },
            },
          },
        },
      ],
    };
  },
  computed: {
    showDialog() {
      return !localStorage.DoNotShowAgain;
    },
    coloradoURL () {
      return (process.env.VUE_APP_PORTAL_URL) ? process.env.VUE_APP_PORTAL_URL : 'https://stg.coloradoforestatlas.org'
    }
  },
  methods: {
    toggleSwipe,
    toggleMeasurement,
    toggleIdentify,
    toggleLegend,
    toogleMenu() {
      this.$store.commit("toogleMenu");
    },
    refresh() {
      window.location.reload(true);
    },
    localStorageAvailable() {
      if (typeof Storage !== "undefined") {
        return true;
      } else {
        return false;
      }
    },
    doNotShowAgain(val) {
      if (val === true) {
        if (this.localStorageAvailable()) {
          localStorage.DoNotShowAgain = true;
        }
      } else {
        localStorage.removeItem("DoNotShowAgain");
      }
    },
    startTour() {
      if (this.showDialog) {
        this.$tours["gettingStarted"].start();
      }
    },
    gettingStartedTour() {
      this.$tours["gettingStarted"].start();
    },
    onResize() {
      const height = document.querySelector("#mainToolbar .v-toolbar__content")
        .style.height;
      this.drawerStyle = {
        "margin-top": `${height}`,
        "max-height": `calc(100% - ${height})`,
        "z-index": 1,
      };
    },
  },
  created() {
    this.$root.$on("snackbar-message", (message) => {
      this.snackbarText = message.text;
      this.snackbar = true;
    });
    eventBus.$on("app-update", () => {
      this.updateSnackbar = true;
    });
    eventBus.$on("start-tour", this.gettingStartedTour);
  },
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
};
</script>

<style lang="stylus" scoped>
.logo-div
  margin 0 1.4em 0 0.5em
  height 47px
  width 47px
  padding-top 7px
.apptittle
  display flex
  flex-direction column
  align-items center
  justify-content center
  font-weight bold
  .subtitle
    letter-spacing .08em
    font-weight 100
</style>

<style lang="stylus">
.view-home
  .snackcontent
    a
      color #dec68a !important
  .v-speed-dial
      top 120px
      right 7px
  .v-step
    z-index 5
    display flex
    flex-direction column
    justify-content center
    align-items center
    padding 0 !important
    background #333333 !important
    .v-step__arrow
      z-index 4
    .header
      display flex
      justify-content flex-start
      align-items center
      width 100%
      height 100%
      padding 1em
      border-top-left-radius .4em
      border-top-right-radius .4em
      background-color #272727
      font-size .9em
    .content
      padding 1em
      justify-content center
      align-items center
      text-align left
      font-size .9em
    .actions
      justify-content center
      align-items center
      padding 0 0 1em 0
    &__content
      text-align left
      ul
        margin-top 1em
    &[x-placement^=bottom]
      margin-left 80px
</style>
